export default function Jsonmdfextract() {
  const element = document.createElement("a");
  element.href = "https://epicx67.github.io/legion_jsonmdfextract";
  element.click();
  return null;
}
